export type TimeRange = {
  startDate: string
  endDate: string
}

export const applyTimeRangeChange = (
  current: TimeRange,
  update: { startDate?: string; endDate?: string }
): TimeRange => {
  const startMs = new Date(current.startDate).getTime()
  const endMs = new Date(current.endDate).getTime()
  const durationMs = endMs - startMs

  if (update.startDate && update.endDate) {
    const newStartMs = new Date(update.startDate).getTime()
    let newEndMs = new Date(update.endDate).getTime()

    if (newEndMs < newStartMs) {
      newEndMs = newStartMs + durationMs
    }

    return {
      startDate: new Date(newStartMs).toISOString(),
      endDate: new Date(newEndMs).toISOString(),
    }
  }

  if (update.startDate) {
    const newStartMs = new Date(update.startDate).getTime()
    return {
      startDate: new Date(newStartMs).toISOString(),
      endDate: new Date(newStartMs + durationMs).toISOString(),
    }
  }

  if (update.endDate) {
    const newEndMs = new Date(update.endDate).getTime()

    if (newEndMs <= startMs) {
      const newStartMs = newEndMs - durationMs
      return {
        startDate: new Date(newStartMs).toISOString(),
        endDate: new Date(newEndMs).toISOString(),
      }
    }

    return {
      startDate: current.startDate,
      endDate: new Date(newEndMs).toISOString(),
    }
  }

  return current
}
